const Announcement = () => {
    const announcement = 'none'

    if (announcement === 'none') {
        return null
    } else if (announcement === 'gala') {
        return (
            <div className='announcement'>
                <div className='announcement-banner'>
                <p className='announcement-banner-text'>Sign up for the Feast of St. Brigid Gala! 🕺💃</p>
                <p className='announcement-banner-text'><a className='league-type' href='https://southietotustuus.rsvpify.com/' target="_blank">Buy tickets here!</a></p>
                </div>
            </div>
        )
    }
}

export default Announcement
